<template>
  <p
    class="m-0 mb-1 font-gt-america-extended tracking-tight uppercase"
    :class="textClass"
    data-test-id="text-tagline"
  >
    {{ tagline }}
  </p>
</template>

<script>
export default {
  props: {
    /**
     * The text that you want displayed
     */
    tagline: {
      type: String,
      required: true
    },
    /**
     * If the text should be light or dark
     */
    textVariant: {
      type: String,
      default: null,
      validator: val => ['light', 'dark', 'gray'].includes(val)
    },
    /**
     * Allows you to specify spacing in different directions.
     */
    spacing: {
      type: String,
      default: null,
      validator: val => ['horizontal', 'vertical', 'top', 'right', 'bottom', 'left'].includes(val)
    }
  },
  computed: {
    textClass () {
      return this.textVariant === 'light'
        ? 'text-white'
        : 'text-dark'
    }
  }
}
</script>
